// sagas.js
import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchRecruiterInvitesSuccess,
  fetchRecruiterInvitesFailure,
} from "./actions";
import { FETCH_RECRUITER_INVITES_REQUEST } from "../../actionTypes";
import AxiosInstance from "../../../services/AxiosInstance";

function* fetchRecruiterInvites(action) {
  const { page, per_page } = action.payload;

  let url = `/recruiter/fetch_invitation?page=${action.payload.page}&per_page=${action.payload.per_page}`;

  if (action.payload.column) {
    url += `&sortBy=${action.payload.column}`;
  }

  if (action.payload.direction) {
    url += `&direction=${action.payload.direction}`;
  }
  
  try {
    const response = yield AxiosInstance().post(url, "");
    if (response.data.status == true) {
      yield put(fetchRecruiterInvitesSuccess(response.data));
    } else {
      yield put(fetchRecruiterInvitesFailure(response.data));
    }
  } catch (error) {
    yield put(
      fetchRecruiterInvitesFailure({ status: false, message: error.message })
    );
  }
}

// Watcher saga
function* fetchRecruiterInviteSaga() {
  yield takeLatest(FETCH_RECRUITER_INVITES_REQUEST, fetchRecruiterInvites);
}
export default fetchRecruiterInviteSaga;
